import { createLazyComponent, LazyModule } from 'owa-bundling';
var lazyModule = new LazyModule(function () {
    return System.import(/* webpackChunkName: "QuickSwitcher" */ './lazyIndex');
});
// Delayed Loaded functions
export var MailQuickSwitcherEntrypoint = createLazyComponent(lazyModule, function (m) { return m.MailQuickSwitcherEntrypoint; });
//# sourceMappingURL=index.js.map